<template>
    <div class="enter">
        <div class="background-i">
        <ul :class="{'over':list.length > 5}">
            <li v-for="(item,index) in list" :key="index">
                <div class="item-content">
                    <!-- <img :src="item.icon" alt=""> -->
                    <h4>{{item.title}}</h4>
                    <p v-html="item.dec"></p>
                    <template>
                        <button v-if="isShowBtn(enterInfo,item) && (AUDITING || REFUSE_MODIFY || REFUSE_TRANSITORY)" @click="progressSearch(item)">申请进度查询</button>
                        <button v-else-if="isShowBtn(enterInfo,item) && NOBIND" @click="bindCode">绑定商家编码</button>
                        <button v-else-if="isShowBtn(enterInfo,item) && TOAUDIT" @click="toNext(item)">继续入驻</button>
                        <button v-else-if="(isShowBtn(enterInfo,item)|| isEdu(enterInfo.buzzType,item.purpose)) && BIND" @click="workbench">进入商家工作台</button>
                        <button v-else-if="item.purpose" @click="nowEnter(item)">申请入驻</button>
                        <button v-else @click="toDetail(item.url)">查看详情</button>
                    </template>
                </div>
            </li>
        </ul>
        </div>
    </div>
</template>
<script>
import {message, Modal} from 'ant-design-vue'
import {isEmpty,find} from 'lodash'
import { mapGetters,mapState } from 'vuex'
import {util,enterStatus,jump,http,enterType} from '@utils'
import {enterInfo} from '@mixins'

export default {
    mixins:[enterInfo],
    props:{
        list:{
            type:Array,
            default(){
                return []
            }
        },
        enterIntercept: {
            type: Object,
            default: () => {}
        }
    },
    methods:{
        isEdu(buzzType,purpose){
            const index = purpose.split(',').findIndex(o => o == buzzType);
            return purpose.split(',').length > 1 && index > -1 ? true :false;
        },
        // isShowBtn(enterInfo,item){
        //     return (+enterInfo.settleInType < +enterType.HANDPICKLIVE && item.purpose == enterInfo.buzzType) || (+item.purpose >= +enterType.HANDPICKLIVE && item.purpose == enterInfo.settleInType);
        // },
        isShowBtn(enterInfo,item){
            return enterInfo.settleInType ? item.purpose == enterInfo.settleInType : item.purpose == enterInfo.buzzType
        },
        nowEnter(item){
            if (this.isShowMask) {
                return Modal.info({
                    title: '友情提醒',
                    content: this.tipContent,
                    centered: true,
                })
            }
            if(util.ensureLogin('enter')){ 
                const enterInfo = this.enterInfo;
                const {enterStatus,buzzType,settleInType,purposeModeName} = enterInfo;
                // if(this.userInfo && this.userInfo.fatherId) {
                //     message.error(`您已成为平台商家的子账号（绑定主账号为：${this.userInfo.fatherNickName}），无法申请入驻。若您想以该账号进行入驻申请，则需先解除子账号绑定。`);
                // } else {
                    //非当前模式
                    const bt = `${settleInType || buzzType}`;
                    if(item.purpose && bt && item.purpose.indexOf(bt) < 0) {
                        //发起申请10,申请提交20,审核通过30,驳回待修改11 -- 已入驻2
                        if(this.TOAUDIT || this.REFUSE_MODIFY || this.AUDITING || this.NOBIND || this.BIND){
                            this.list.forEach((el)=>{
                                if(el.purpose && el.purpose.indexOf(bt) > -1) {
                                     message.error(`您已申请${el.title}模式合作，若您想与孩子王进行其他模式合作，需注册新账号进行申请`);
                                }
                            })
                            
                        } /*else if(this.BIND){//已入驻2
                            this.workbench();
                        }*/ else {
                           this.toNext(item);
                        }
                       
                    } else {
                        this.toNext(item);
                    }
                //}
            }
        },
        async toNext(item){
            if (this.isShowMask) {
                return Modal.info({
                    title: '友情提醒',
                    content: this.tipContent,
                    centered: true,
                })
            }
            if(item.type) {
                this.bindCode();
            } else {
                jump.goOnEnter(item.purpose, item)
                // const response = await http.get('//bpc.haiziwang.com/api/v2/apply/check',{
                //     params:{purpose:item.purpose},
                //     credentials: 'include',
                //     withCredentials: true
                // })
                // if(response && response.code == 1001 && response.data && response.data.form_status){
                //     const form_status = response.data.form_status;
                //     const obj = find(form_status,o =>o.status != 1);
                //     if(obj && obj.type) {
                //         location.href = `${item.url}/${obj.type}`;
                //     } else {
                //         location.href = item.url;
                //     }
                // } else {
                //     location.href = item.url;
                // }
            }
        },
        progressSearch(){
            if (this.isShowMask) {
                return Modal.info({
                    title: '友情提醒',
                    content: this.tipContent,
                    centered: true,
                })
            }
            jump.enterProgress();
        },
        bindCode(){
            jump.accountBindCode();
        },
        workbench(){
            jump.workbench()
        },
        toDetail(url){
            window.open(url)
        }
    },
    computed:{
        ...mapState(['userInfo']),
        isShowMask() {
            return this.enterIntercept && this.enterIntercept.show
        },
        tipContent() {
            return this.enterIntercept && this.enterIntercept.text
        }
    }
}
</script>
<style lang="scss" scoped>
.enter {
    background-color: #f6f8fb;
    width: 100%;
}
.background-i {
    @include Flex;
    justify-content: center;
    height: auto;
    padding-bottom: 55px;
    // background: url('~@assets/images/home/bg_enter@2x.png') no-repeat bottom;
    // background-size: 1920px 848px;
    
    
    &> ul {
        // @include Width;
        width: 1092px;
        @include Flex;
        max-width: 100%;
        &.over {
            flex-wrap: wrap;
            li {
                width: 33.33%;
                padding: 9px;
                // height:  227px;
            }
        }
        @include Transition;
        @media #{$media} {
            width: 1100px!important;
        }
        li {
            padding: 5px;
            @include Transition;
            width: 20%;
            .item-content {
                border-radius: 15px;
                // padding:  0 24px;
                background: url('~@assets/images/enter-bg.png') no-repeat center;
                border-radius: 15px;
                padding-top: 16px;
                padding-bottom: 32px;
                text-align: center;
                img {
                    width: 50px;
                    height: 50px;
                }
                h4 {
                    margin-top: 14px;
                    font-size: 20px;
                    color: #FFFFFF;
                    line-height: 28px;
                    margin-bottom: 18px;
                    @include Transition;
                    @media #{$media} {
                        font-size: 18px;
                    }
                }
                p {
                    font-size: 13px;
                    color: #FFFFFF;
                    line-height: 23px;
                    height: 69px;
                    text-align: center;
                }
                button {
                    margin-top: 15px;
                    border: 0;
                    color: #FFFFFF;
                    border-radius: 19px;
                    height: 39px;
                    line-height: 38px;
                    // padding: 0 16px;
                    width: 150px;
                    background-color: rgba(255,255,255, 0.23);
                    cursor: pointer;
                    border: 1px solid #fff;
                    text-align: center;

                    &:hover{
                        background-color: #fff;
                        color: #231d97;
                    }
                }
            }
        }
    }
}
</style>


